import * as React from "react"
import { LoaderCircle } from '../../../accommodations/models/loading'


export const PageLoader = (
  props: {}
) => (
  <div className="page-section page-section--pt">
    <div className="grid-container tac">
      <div className="grid-70 suffix-15 prefix-15 tablet-grid-70 tablet-suffix-15 tablet-prefix-15">
        <LoaderCircle />
        {I18n.t('search.infowindow.loading')}
      </div>
    </div>
  </div>
);
